export default __webpack_public_path__ + "static/media/download-grey.5bc86934.svg";